import React from 'react';
import SEO from '../components/SEO';

const Terms = () => {
  return (
    <article
      aria-labelledby="terms-title"
      className="mx-auto w-full max-w-4xl px-6 py-24 font-mono text-xs uppercase leading-loose text-black"
    >
      <SEO
        title="Terms of Service"
        description="Read the Broadway Muses Terms of Service governing access to and use of the website."
        path="/terms"
      />

      <header className="mb-16 border-b-8 border-black pb-4">
        <h1
          id="terms-title"
          className="break-words font-serif text-4xl font-black italic md:text-7xl"
        >
          Terms of Service
        </h1>
      </header>

      <div className="space-y-12">
        <section
          aria-labelledby="terms-acceptance"
          className="border-l-4 border-black pl-6"
        >
          <h2 id="terms-acceptance" className="mb-4 text-xl font-bold">
            1. Acceptance of Terms
          </h2>
          <p>
            By accessing or using the Broadway Muses website, you agree to be
            bound by these Terms of Service and all applicable laws and
            regulations.
          </p>
        </section>

        <section
          aria-labelledby="terms-license"
          className="border-l-4 border-black pl-6"
        >
          <h2 id="terms-license" className="mb-4 text-xl font-bold">
            2. Use License
          </h2>
          <p>
            The content on this website is for your personal, non-commercial use
            only. You may not modify, copy, or distribute the materials without
            our express written consent.
          </p>
        </section>

        <section
          aria-labelledby="terms-disclaimer"
          className="border-l-4 border-black pl-6"
        >
          <h2 id="terms-disclaimer" className="mb-4 text-xl font-bold">
            3. Disclaimer
          </h2>
          <p>
            The materials on the Broadway Muses website are provided on an 'as
            is' basis. We make no warranties, expressed or implied, and hereby
            disclaim and negate all other warranties.
          </p>
        </section>

        <section
          aria-labelledby="terms-limitations"
          className="border-l-4 border-black pl-6"
        >
          <h2 id="terms-limitations" className="mb-4 text-xl font-bold">
            4. Limitations
          </h2>
          <p>
            In no event shall Broadway Muses or its suppliers be liable for any
            damages arising out of the use or inability to use the materials on
            the website.
          </p>
        </section>
      </div>
    </article>
  );
};

export default Terms;